<template>
  <div class="row">
    <BrandWizardNavigation />
    <div class="col">
      <b-card>
        <FormBuilder
          label="Brand"
          create
          :fields="fields"
          :loading-submit="$store.state.brandV2.loadingSubmit"
          @submit="submitData"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import BrandWizardNavigation from '@/components/brand/BrandWizardNavigation.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/brand'

export default {
  components: {
    BCard,
    FormBuilder,
    BrandWizardNavigation,
  },
  setup() {
    return { fields }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('brandV2/create', data)
        .then(() => {
          if (typeof callback === 'function') callback()
          this.$router.push({ name: 'brands-v2' })
        })
        .catch(err => callback(err))
    },
  },
}
</script>
